import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import NavBar from './mobile/NavBar';
import LanguageSelect from './mobile/LanguageSelect';

export default class MobileLeftPanel extends React.Component {
	render() {
		return (
			<div className="msidebar-left-wrap" id="J-msidebar-left">
				<div className="msidebar-left">
					<NavBar />
					<LanguageSelect />
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./app/components/MobileLeftPanel.js